import * as React from 'react';

import CheckboxesList from 'components/inputs/checkboxes-list/CheckboxesList';

import { expandDataProps } from 'utils/helper/common';

import type { CheckboxesListItem, Data } from 'types';

import type { SyntheticEvent } from 'react';

type Props = {
  items: Array<CheckboxesListItem>,
  highlightedId?: number | string,
  containerClass?: string,
  data?: Data,
  onCheckboxChange: (a: SyntheticEvent<HTMLElement>, item: CheckboxesListItem) => void,
  onCheckboxRemove?: (a: SyntheticEvent<HTMLElement>, item: CheckboxesListItem) => void
};

const SOVQueriesInputCheckbox = (
  {
    items,
    highlightedId,
    containerClass,
    data,
    onCheckboxChange,
    onCheckboxRemove
  }: Props
): JSX.Element => {
  let additionalProps = {};

  if (highlightedId) {
    additionalProps = {
      highlightedId
    };
  }

  return (
    <CheckboxesList
      {...additionalProps}
      {...expandDataProps(data)}
      lists={items}
      emptyLabel=""
      size="small"
      customContainerClass={containerClass}
      onCheckboxChange={onCheckboxChange}
      onCheckboxRemoved={onCheckboxRemove}
    />
  );
};

export default SOVQueriesInputCheckbox;
